import React from 'react';

import { LiveSessionWrapper } from '../SessionComponent';
import { ManagedStatus, startPublicChat, ThemeWrapper } from '@amzn/ring-cs-chatbot-widget';

const widgetOpen = true; // view receipts
const windowType = 'desktop'; // desktop for testing
const onNewMessage = () => console.log('onNewMessage');
const onPlayAudio = () => console.log('onPlayAudio');
const onToggleWidget = () => console.log('onToggleWidget');
const handleStatusChange = (status: ManagedStatus) => {
    console.log('Chat status:', status);
};
const onClickStart = async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const campaign = searchParams.get('campaign') || 'ACEC_US';
    const market = searchParams.get('market') || 'en-US';
    const resumeToken = searchParams.get('resumeToken') || undefined;

    // Call startPublicChat with campaign and resumeToken (undefined if not present)
    await startPublicChat({ campaign, market, resumeToken });
};

// FOR DEMO USE ONLY
export function UnframedTest () {
    return (
        <ThemeWrapper>
            <LiveSessionWrapper
                widgetOpen={widgetOpen}
                windowType={windowType}
                onNewMessage={onNewMessage}
                onPlayAudio={onPlayAudio}
                onToggleWidget={onToggleWidget}
                onStatusHandler={handleStatusChange}
                onClickStart={onClickStart}
            />
        </ThemeWrapper>
    );
}
